export default "__VITE_ASSET__b148a58c__"